import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { useFloatingTree, useListItem, useMergeRefs } from '@floating-ui/react';
import { ListItem } from '../ListItem';
import { Menu } from '../Menu';
import { MenuItemContext } from './MenuItem.context';
import { MenuNestedItem } from './MenuNestedItem';
export const MenuItem = forwardRef(function MenuItem(props, forwardedRef) {
    const { children, label, keepOpenOnClick, ...other } = props;
    const menuItemContext = useContext(MenuItemContext);
    const item = useListItem({ label: props.disabled ? null : undefined });
    const tree = useFloatingTree();
    const handleRef = useMergeRefs([item.ref, forwardedRef]);
    const isActive = item.index === menuItemContext.activeIndex;
    const renderListItem = () => (_jsx(ListItem, { role: 'menuitem', tabIndex: isActive ? 0 : -1, visualState: { hovered: isActive, strategy: 'replace' }, ...menuItemContext.getItemProps({
            ...other,
            onClick: (event) => {
                other.onClick?.(event);
                if (!keepOpenOnClick) {
                    tree?.events.emit('click');
                }
            },
        }), ref: handleRef, children: label }));
    return children ? (_jsx(Menu, { trigger: () => _jsx(MenuNestedItem, { label: label, ...other }), children: children })) : (renderListItem());
});
